import React from 'react';
import PropTypes from 'prop-types';

import SuiContainer from '@splashthat/sui/lib/components/SuiContainer';

import { FormBuilderContext } from '../FormBuilder/FormBuilder';

const LayoutNodeContentContainer = ({
    children,
    depth,
    isActive,
    canEdit,
    onMouseEnter,
    onMouseLeave,
    onClick,
    ...props
}) => {
    const baseClassName = 'LayoutNodeContentContainer';

    return (
        <FormBuilderContext.Consumer>
            {({ permissions: { canUserEditForm: canUserAccess } }) => (
                <SuiContainer
                    className={[
                        baseClassName,
                        `${baseClassName}--depth-${depth}`,
                        canUserAccess && canEdit && `${baseClassName}--is-editable`,
                        canUserAccess && isActive && 'is-active',
                    ]
                        .filter((v) => v)
                        .join(' ')}
                    variation="flex-inherit-vertical flex-horizontal"
                    {...(canUserAccess
                        ? {
                              onMouseEnter,
                              onMouseLeave,
                              onClick,
                              ...props,
                          }
                        : {
                              ...props,
                          })}
                >
                    {children}
                </SuiContainer>
            )}
        </FormBuilderContext.Consumer>
    );
};

LayoutNodeContentContainer.propTypes = {
    children: PropTypes.node.isRequired,
    depth: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired,
    canEdit: PropTypes.bool.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default LayoutNodeContentContainer;
